import { ChangeDetectionStrategy } from '@angular/core';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { ApplicationListConst } from '@ispm/navigation/components/navigationBarAppLauncher/applicationList.const';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { INavigationApplicationInterface } from '@ispm/navigation/interfaces';
import _ from 'lodash';

@Component({
  selector: 'gen-navigation-app-launcher',
  templateUrl: './navigationBarAppLauncher.component.html',
  styleUrls: ['./navigationBarAppLauncher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBarAppLauncherComponent implements OnInit {
  @Input() public applications: INavigationApplicationInterface[];
  @Input() public currentApp: INavigationApplicationInterface;

  @Output() public OnAppLauncherClick: EventEmitter<INavigationApplicationInterface> = new EventEmitter<INavigationApplicationInterface>();

  public groupList = [];

  private applicationList = ApplicationListConst;
  private groupedAppList = [];
  private isHidden: boolean = false;

  constructor(
    private authService: AuthenticationService
  ) {
  }

  public ngOnInit() {
    this.isHidden = this.applications && this.applications.length < 2;

    // Generate unique `groupList`
    this.groupList = _.uniq(_.map(this.applicationList, 'group'));

    // Map and filter `applications` into `groupedAppList` with lodash chaining
    this.groupedAppList = _(this.applications)
      .map((item) => {
        const matchedApp = _.find(this.applicationList, { name: item.text });
        const mergedApp = matchedApp ? { ...item, ...matchedApp } : item;

        // Assign a default group if not present, excluding items with `text` of "Applications List"
        if (!mergedApp.group && mergedApp.text !== 'Applications List') {
          mergedApp.group = 'Other / Non-Oncology';
        }
        return mergedApp;
      })
      .filter(item => item.enable && item.group && _.includes(this.groupList, item.group))
      .value();
  }

  public onClick($event): void {
    const app: INavigationApplicationInterface = this.applications.find(ap => ap.id === $event);
    this.OnAppLauncherClick.emit(app);
    this.authService.updateLocalSettings('worklistSearchText', '');
    this.authService.updateLocalSettings('worklistSearchResource', '');
  }

  public getColor(identify: string) {
    if (identify === this.currentApp.id) {
      return '#1474A4';
    }
  }

  public get enabledGroupedApps() {
    return _.groupBy(this.groupedAppList, 'group');
  }
}
